<template>
    <div v-show="companyIsLoaded" :class="{'is-collapsed': isSidebarCollapsed}">
        <component :is="TheSidebar" :is-admin="isAdmin" @collapse="isSidebarCollapsed = false" />

        <div class="page-container">
            <TheHeader @sidebar="isSidebarCollapsed = !isSidebarCollapsed" />

            <div class="main-content">
                <transition mode="out-in" enter-active-class="fadeIn" leave-active-class="fadeOut" appear>
                    <router-view class="animated" @sidebar="isSidebarCollapsed = !isSidebarCollapsed" />
                </transition>
            </div>

            <TheFooter class="footer-base" />
        </div>

        <vue-snotify />
    </div>
</template>

<script>
import TheSidebar from '@/components/TheSidebar'
import TheAdminSidebar from '@/components/admin/TheSidebar'
import TheHeader from '@/components/TheHeader'
import TheFooter from '@/components/TheFooter'

export default {
    components: {
        TheHeader,
        TheFooter
    },

    computed: {
        isSidebarCollapsed: {
            get() {
                return this.$store.state.isSidebarCollapsed
            },
            set(value) {
                this.$store.commit('SET_SIDEBAR', value)
            }
        },

        companyIsLoaded() {
            return this.$store.getters['company/isLoaded'] || this.$store.state.auth.isAdmin
        },

        isMobile() {
            return this.$store.state.isMobile
        },

        isAdmin() {
            return this.$store.state.auth.isAdmin
        },

        TheSidebar() {
            return (this.$route.meta && this.$route.meta.adminArea)
                ? TheAdminSidebar
                : TheSidebar
        }
    }
}
</script>
